import Vue from 'vue'
import Vuex from 'vuex'
import clients from './clients'
import permissions from './permissions'
import dashboard from './dashboard'
import draw from './draw'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters: {},
  actions: {},
  mutations: {},
  modules: {
    clients,
    permissions,
    dashboard,
    draw
  }
})
